var _rect, _rect2, _rect3, _rect4, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuiqi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 14,
    width: 16,
    height: 2,
    transform: "rotate(-180 16 14)",
    fill: "#00C2FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 16,
    width: 6,
    height: 2,
    transform: "rotate(-90 14 16)",
    fill: "#00C2FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 6,
    height: 2,
    transform: "rotate(-90 0 16)",
    fill: "#00C2FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 9.5,
    width: 11,
    height: 3,
    transform: "rotate(-180 13.5 9.5)",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3C2.5 2.46299 2.94833 1.84221 3.98097 1.32589C4.98369 0.82453 6.40394 0.5 8 0.5C9.59606 0.500001 11.0163 0.82453 12.019 1.32589C13.0517 1.84221 13.5 2.46299 13.5 3C13.5 3.53701 13.0517 4.15779 12.019 4.67411C11.0163 5.17547 9.59606 5.5 8 5.5C6.40394 5.5 4.98369 5.17547 3.98097 4.67411C2.94833 4.15779 2.5 3.53701 2.5 3Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuiqi);
export default __webpack_public_path__ + "static/media/duiqi.cb046c606e166c585f2ca5dabf8a16cf.svg";
export { ForwardRef as ReactComponent };